import { useEffect } from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'
import { loginUrl } from './helper'
import Logo from '../../shared/Logo'
import PropTypes from 'prop-types'
import logRedirect, { sendBreadcrumbsNow } from '../../helper/RedirectLogger'

const redirectUri = window.location.origin + '/login/target'
const clientId = process.env.REACT_APP_CLIENT_ID

// Hilfsfunktion zum sicheren Parsen von URLs
const parseUrlSafely = url => {
	if (!url) {
		return {
			hostname: null,
			pathname: null,
			search: null,
		}
	}
	try {
		const parsed = new URL(url)
		return {
			hostname: parsed.hostname,
			pathname: parsed.pathname,
			search: parsed.search,
		}
	} catch (error) {
		return {
			hostname: null,
			pathname: null,
			search: null,
			parseError: error.message,
		}
	}
}

const ToRedirect = props => {
	const [searchParams] = useSearchParams()
	const iotaLoginURL = loginUrl(
		redirectUri,
		clientId,
		props.allowSSO ? searchParams.get('sso_id') : null
	)

	useEffect(() => {
		const targetUrlInfo = parseUrlSafely(iotaLoginURL)

		// Initiales Logging mit allen Details
		logRedirect('ToRedirect', {
			action: 'Component mounted - Preparing redirect to SSO',
			redirectTarget: iotaLoginURL,
			redirectTargetHost: targetUrlInfo.hostname,
			redirectTargetPath: targetUrlInfo.pathname,
			redirectTargetSearch: targetUrlInfo.search,
			allowSSO: props.allowSSO,
			ssoId: props.allowSSO ? searchParams.get('sso_id') : null,
			currentUrl: window.location.href,
			currentPath: window.location.pathname,
			currentSearch: window.location.search,
			referrer: document.referrer,
			delay: '2000ms',
			redirectUri,
			clientId,
		})

		const timeoutId = setTimeout(() => {
			const targetUrlInfoBeforeRedirect = parseUrlSafely(iotaLoginURL)

			// Logging kurz vor dem Redirect
			logRedirect('ToRedirect', {
				action: 'About to redirect - window.location.href will be set',
				from: window.location.href,
				fromHost: window.location.hostname,
				fromPath: window.location.pathname,
				to: iotaLoginURL,
				toHost: targetUrlInfoBeforeRedirect.hostname,
				toPath: targetUrlInfoBeforeRedirect.pathname,
				toSearch: targetUrlInfoBeforeRedirect.search,
			})

			// Wichtiger Breadcrumb VOR dem SSO-Redirect mit allen Details
			sendBreadcrumbsNow('ToRedirect', {
				action: 'Redirecting to SSO - Final redirect event',
				from: window.location.href,
				fromHost: window.location.hostname,
				fromPath: window.location.pathname,
				fromSearch: window.location.search,
				to: iotaLoginURL,
				toHost: targetUrlInfoBeforeRedirect.hostname,
				toPath: targetUrlInfoBeforeRedirect.pathname,
				toSearch: targetUrlInfoBeforeRedirect.search,
				allowSSO: props.allowSSO,
				ssoId: props.allowSSO ? searchParams.get('sso_id') : null,
				redirectUri,
				clientId,
				referrer: document.referrer,
			})

			window.location.href = iotaLoginURL
		}, 2000)

		return () => {
			clearTimeout(timeoutId)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="absolute flex flex-col w-full gap-8 p-10 -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 font-montserrat">
			<div className="text-4xl font-semibold text-center">Willkommen zurück!</div>
			<div className="relative flex justify-center">
				<Logo
					file="senshub_trans.svg"
					alt="SENSHUB_transparent"
					className="h-24 text-logo md:h-32"
				/>
			</div>
			<div className="text-xl text-center">
				<div>Sie werden nun auf unsere externe Loginseite weitergeleitet.</div>
				<div>
					Sollten Sie nach 5 Sekunden immer noch nicht weitergeleitet werden, klicken
					Sie bitte
					<NavLink to={iotaLoginURL}>
						<b> hier</b>
					</NavLink>
					!
				</div>
			</div>
		</div>
	)
}

ToRedirect.propTypes = {
	allowSSO: PropTypes.bool,
}

export default ToRedirect
